import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section id="cta" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-0 rounded-xl overflow-hidden border border-background-200/70">
          {/* Left - Image */}
          <div className="lg:w-1/2 relative h-[300px] lg:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20e-commerce%20workspace%20with%20organized%20product%20samples%20fashion%20items%20accessories%20and%20spreadsheet%20printouts%20on%20light%20wooden%20desk%2C%20warm%20natural%20lighting%20from%20large%20window%2C%20minimalist%20aesthetic%20with%20cream%20and%20warm%20beige%20tones%2C%20professional%20product%20research%20environment%20with%20laptop%20and%20organized%20documents%2C%20soft%20organic%20shadows%20and%20balanced%20composition&width=1280&height=840&seq=cta-product-scene-v2&orientation=landscape"
              alt="OOPBuy Spreadsheet product research workspace"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-0 left-0 p-6 md:p-8">
              <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white leading-tight drop-shadow-lg">
                Smarter<br />Sourcing<br />Starts Here
              </p>
            </div>
          </div>

          {/* Right - Content */}
          <div className="lg:w-1/2 bg-white p-8 md:p-12 flex flex-col justify-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4 leading-tight">
              Start Using OOPBuy Spreadsheet Today
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-sm">
              Stop guessing what products to sell. Start using structured data to make smarter decisions and grow your e-commerce business with confidence.
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-sm">
              Join thousands of users leveraging spreadsheet intelligence to improve their product research strategy.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3 rounded-full bg-foreground-800 text-white text-sm font-medium hover:bg-foreground-900 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Buy It Now <i className="ri-arrow-right-up-line ml-1 align-middle"></i>
              </a>
              <Link
                to="/oopbuy-spreadsheet-guide"
                className="px-8 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 text-sm font-medium hover:border-accent-400 hover:text-accent-600 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Read Our Guide <i className="ri-arrow-right-line ml-1 align-middle"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}